var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5012",
    x: 0,
    y: 0,
    width: 53,
    height: 53,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536",
    transform: "translate(-708 -377)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 708, 377)",
    filter: "url(#Rectangle_5012)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5012-2",
    "data-name": "Rectangle 5012",
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(9 6)",
    fill: "#C2FAE5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532",
    transform: "translate(1.936 43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-back-1144365_1_",
    "data-name": "noun-back-1144365 (1)",
    transform: "translate(729.064 351.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12445",
    "data-name": "Path 12445",
    d: "M274.663,149.922a.891.891,0,0,1,1.259-1.259l5.089,5.089a.891.891,0,0,1,0,1.259l-5.089,5.089a.891.891,0,0,1-1.259-1.259l4.462-4.462Z",
    transform: "translate(-274.402 -148.402)",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.79360c5b42b6936775dd5dac31f8e974.svg";
export { ForwardRef as ReactComponent };